module.exports = __webpack_public_path__ + "static/media/3.bebc3795.svg";